"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardModeEnumArray = exports.CardModeEnum = void 0;
var CardModeEnum;
(function (CardModeEnum) {
    CardModeEnum["DEBIT_MODE"] = "DEBIT_MODE";
    CardModeEnum["PREPAID_MODE"] = "PREPAID_MODE";
})(CardModeEnum || (exports.CardModeEnum = CardModeEnum = {}));
exports.cardModeEnumArray = Object.values(CardModeEnum);
